import { render, staticRenderFns } from "./numeric-editor.vue?vue&type=template&id=365f8e02&"
import script from "./numeric-editor.vue?vue&type=script&lang=js&"
export * from "./numeric-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports